import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import {
  PBX_CLASS_TYPES,
  PBX_DIAL_PLAN_RULE_SETS,
  PBX_REGIONS,
  PBX_TYPES,
} from "./constants";
import * as yup from "yup";
import DeleteActionCell from "./components/DeleteActionCell";
import DialPlanNameSelect from "../dialplans/DialPlanNameSelect";
import { addressSelectorCellFactory } from "@/react/features/smp/address-management/addressSelectorCellFactory";
import { addressSelectorColumnSetterFactory } from "@/react/features/smp/address-management/addressSelectorColumnSetterFactory";
import LocaleSelect from "@/react/features/smp/cells/LocaleSelect";
import TimezoneSelect from "@/react/features/smp/cells/TimezoneSelect";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      { ...getColumnDef(schema.fields.pbxId, "ID"), type: TYPES.ID },
      {
        ...getColumnDef(schema.fields.name, "Name"),
        customCell: ({ getValue }) => <strong>{getValue()}</strong>,
        editable: true,
        sticky: true,
      },
      {
        ...getColumnDef(schema.fields.region, "Region"),
        editable: true,
        type: TYPES.SELECT,
        options: PBX_REGIONS,
      },
      {
        ...getColumnDef(schema.fields.status, "Status"),
      },
      {
        ...getColumnDef(yup.reach(schema, "details.type"), "Type"),
        editable: true,
        type: TYPES.SELECT,
        options: PBX_TYPES,
      },
      {
        ...getColumnDef(schema.fields.locale, "Locale"),
        editable: true,
        editableCell: LocaleSelect,
      },
      {
        ...getColumnDef(schema.fields.timezoneId, "Timezone"),
        editable: true,
        editableCell: TimezoneSelect,
      },
      {
        ...getColumnDef(yup.reach(schema, "details.classType"), "Class Type"),
        editable: true,
        type: TYPES.SELECT,
        options: PBX_CLASS_TYPES,
      },
      {
        ...getColumnDef(schema.fields.dialPlanName, "Dialplan Name"),
        editable: true,
        editableCell: DialPlanNameSelect,
      },
      {
        ...getColumnDef(
          schema.fields.dialPlanRuleSetName,
          "Dialplan Rule Set Nane"
        ),
        editable: true,
        type: TYPES.SELECT,
        options: PBX_DIAL_PLAN_RULE_SETS,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.maxSwitchBoardConnections"),
          "Max Switch Board Connections"
        ),
        editable: true,
        type: TYPES.NUMBER,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.emergencyAddress.freeForm"),
          "Emergency Address"
        ),
        editable: true,
        editableCell: addressSelectorCellFactory(
          yup.reach(schema, "details.emergencyAddressId").spec.key
        ),
        columnSetter: addressSelectorColumnSetterFactory(
          yup.reach(schema, "details.emergencyAddressId").spec.key
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.emergencyAddressId"),
          "Address ID"
        ),
        type: TYPES.ID,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.extensionLength"),
          "Extension Length"
        ),
        editable: true,
        type: TYPES.NUMBER,
      },
      {
        id: "pbx_actions",
        header: "",
        accessorFn: (pbx) => pbx.pbxId,
        customCell: DeleteActionCell,
        disableCopy: true,
        size: 200,
        enableDownload: false,
        enableSorting: false,
        enableColumnFilter: false,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
